// @flow
import React from "react"
import { type HOC } from "recompose"
import withRouter from "hoc/withRouter"
import { isNil, isEmpty, values, omit } from "ramda"
import type { Location, ProductGroup } from "data/app/types"
import BrandFilter from "searchFilters/FilterComponents/BrandFilter"
import ProductFilter from "searchFilters/FilterComponents/ProductFilter"
import { chooseGeolocation, chooseProductGroups } from "data/app/actions"
import { formatLocation, formatProductGroupFilter } from "data/app/formatters"
import { type SearchParams } from "data/search/types"
import { filter, clear } from "data/search/actions"
import { formatEnumArray } from "data/enums/formatters"
import DesktopFilter from "searchFilters/Shared/DesktopFilter"
import LocationFilter from "searchFilters/FilterComponents/LocationFilter"
import PassportFilter from "searchFilters/FilterComponents/PassportFilter"
import ProductGroupFilter from "searchFilters/FilterComponents/ProductGroupFilter"
import { ClearButton } from "./styled"

type Props = {|
  geolocation: ?Location[],
  productGroups: ?ProductGroup[],
  clear: typeof clear,
  chooseGeolocation?: typeof chooseGeolocation,
  chooseProductGroups: typeof chooseProductGroups,
  params: SearchParams,
  filter: typeof filter,
  noPassport: boolean,
|}

const DesktopFilters = ({
  chooseGeolocation,
  geolocation,
  productGroups,
  chooseProductGroups,
  filter,
  clear,
  params,
  location,
  noPassport = false,
}) => {
  // Affiliate filter value is context from the affiliate page so it's not clearable
  const filterParams = omit(['affiliate'], params)
  const filterEmpty =
    (
      isNil(filterParams)
      || isEmpty(filterParams)
      || values(filterParams).every(isNil)
      || values(filterParams).every(isEmpty)
    )

  return (
    <React.Fragment>
      <DesktopFilter
        value={productGroups}
        onChange={chooseProductGroups}
        component={ProductGroupFilter}
        formatter={formatProductGroupFilter("Product Type")}
        title="Product Type"
      />
      {chooseGeolocation && (
        <DesktopFilter
          value={geolocation}
          onChange={chooseGeolocation}
          component={LocationFilter}
          formatter={formatLocation}
          title="Location"
          minWidth={28}
          closeOnChange
        />
      )}
      <DesktopFilter
        value={params.brand}
        onChange={brand => filter({ brand })}
        formatter={formatEnumArray("Brand")}
        component={BrandFilter}
        title="Brand"
        noXPadding
      />
      <DesktopFilter
        value={params.product}
        onChange={product => filter({ product })}
        formatter={formatEnumArray("Product")}
        component={ProductFilter}
        title="Product"
        noXPadding
      />
      {!noPassport &&
        <DesktopFilter
          value={params.discountId}
          onChange={filter}
          component={PassportFilter}
          formatter={() => "Passport"}
          title="Passport"
          noControls
          flexDirection="row"
        />
      }
      {!filterEmpty && <ClearButton primary onClick={clear}>Clear</ClearButton>}
    </React.Fragment>
  )
}

const enhancer: HOC<*, Props> = withRouter

export default enhancer(DesktopFilters)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainFilter/DesktopFilters/index.js